module.exports = __webpack_public_path__ + "static/teleco_12-05190e0c3f439ffa70037983a923f57a.jpg";